import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Text } from '@alfa-bank/site-text-v2';

import type { TAlfaleasingCompanyBannerDesktop, IDepsDesktop } from '../models';

import { AlfaleasingCompanyBanner as Component } from './desktop';
import styles from './styles.css';

// eslint-disable-next-line styler/check-styler
export const AlfaleasingCompanyBannerDesktop = createWidget<
    IDepsDesktop,
    TAlfaleasingCompanyBannerDesktop
>({
    Text,
    styles,
})(Component);
